var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M13.1905 21.005V19.4812C13.1905 18.6729 12.8694 17.8978 12.2978 17.3262C11.7263 16.7547 10.9511 16.4336 10.1429 16.4336H4.04762C3.23934 16.4336 2.46417 16.7547 1.89263 17.3262C1.32109 17.8978 1 18.6729 1 19.4812V21.005",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M7.09523 12.3843C8.77838 12.3843 10.1428 11.0198 10.1428 9.33668C10.1428 7.65353 8.77838 6.28906 7.09523 6.28906C5.41207 6.28906 4.04761 7.65353 4.04761 9.33668C4.04761 11.0198 5.41207 12.3843 7.09523 12.3843Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22.3333 7.2381C22.335 7.74091 22.1784 8.23691 21.8761 8.68572C21.5177 9.22352 20.9668 9.67588 20.285 9.99211C19.6032 10.3083 18.8175 10.476 18.0158 10.4762C17.3454 10.4775 16.6841 10.36 16.0857 10.1333L13.1904 10.8571L14.1555 8.68572C13.8533 8.23691 13.6966 7.74091 13.6984 7.2381C13.6987 6.63687 13.9222 6.04757 14.3438 5.53622C14.7654 5.02487 15.3686 4.61165 16.0857 4.34287C16.6841 4.11617 17.3454 3.9987 18.0158 4.00001H18.2698C19.3285 4.04382 20.3285 4.37897 21.0782 4.94129C21.828 5.50361 22.2749 6.25359 22.3333 7.04762V7.2381Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }